import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["selectTheme"];
var _FontAwesomeIcon;
/* eslint-disable no-nested-ternary */
import { faAngleDown, faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import ReactSelect from "react-select";
import { components } from "react-select";
var styles = {
  "caret-icon-svg": "pbui-28E0-",
  "clear-icon": "pbui-YWhCJ",
  "clear-icon-svg": "pbui-tYnTW",
  "label": "pbui-ufffz"
};
import { SelectLabel } from "./SelectLabel";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CaretDownIcon = function CaretDownIcon() {
  return /*#__PURE__*/_jsx(FontAwesomeIcon, {
    icon: faAngleDown,
    className: styles["caret-icon-svg"],
    size: "sm"
  });
};
var MultiValueRemoveIcon = function MultiValueRemoveIcon(_ref) {
  var innerProps = _ref.innerProps;
  return /*#__PURE__*/_jsx("div", _extends({}, innerProps, {
    className: styles["clear-icon"],
    children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: faTimes,
      className: styles["clear-icon-svg"],
      size: "xs"
    })
  }));
};
var ClearIcon = function ClearIcon(_ref2) {
  var innerProps = _ref2.innerProps;
  return /*#__PURE__*/_jsx("div", _extends({}, innerProps, {
    style: {
      paddingInline: 10,
      cursor: 'pointer'
    },
    children: _FontAwesomeIcon || (_FontAwesomeIcon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: faTimes
    }))
  }));
};
var CustomInput = function CustomInput(props) {
  return /*#__PURE__*/_jsx(components.Input, _extends({}, props, {
    autoComplete: "one-time-code"
  }));
};
var Select = function Select(_ref3) {
  var _ref3$selectTheme = _ref3.selectTheme,
    selectTheme = _ref3$selectTheme === void 0 ? "default" : _ref3$selectTheme,
    props = _objectWithoutProperties(_ref3, _excluded);
  var components = {
    DropdownIndicator: CaretDownIcon,
    MultiValueRemove: MultiValueRemoveIcon,
    ClearIndicator: ClearIcon,
    Input: CustomInput // Added the custom Input component
  };

  if (props.noSeparator) {
    components = _extends({}, components, {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.label && /*#__PURE__*/_jsx(SelectLabel, {
      className: props == null ? void 0 : props.labelClassName,
      id: props.id,
      children: props.label
    }), /*#__PURE__*/_jsx(ReactSelect, _extends({
      components: components,
      instanceId: props == null ? void 0 : props.id,
      styles: {
        control: function control(base, state) {
          return _extends({}, base, {
            display: "flex",
            border: props.noBorder ? "none" : state.isFocused ? selectTheme === "orange" ? "1px solid #E62E05" : "1px solid #AB95EA" : "1px solid rgb(234 236 240)",
            boxShadow: !props.noBorder && state.isFocused ? selectTheme === "orange" ? "0px 0px 0px 4px #FCD3B0" : "0px 0px 0px 4px #CCBFF2" : "none",
            "&:hover": {
              border: props.noBorder ? "none" : state.isFocused ? selectTheme === "orange" ? "1px solid #E62E05" : "1px solid #AB95EA" : "1px solid rgb(234 236 240)"
            },
            borderRadius: 4,
            fontSize: 14,
            fontWeight: 400,
            height: props.customHeight ? "".concat(props.customHeight, "px") : base.height,
            minHeight: props.customHeight ? "".concat(props.customHeight, "px") : base.minHeight
          });
        },
        placeholder: function placeholder(base) {
          return _extends({}, base, {
            fontSize: 14
          });
        },
        input: function input(base) {
          return _extends({}, base, {
            borderColor: selectTheme === "orange" ? "#E62E05" : base.borderColor,
            "> input": {
              border: 'none !important',
              boxShadow: "none !important",
              autoComplete: "one-time-code",
              // Optional fallback here, though now unnecessary
              "&:focus": {
                border: 'none !important',
                boxShadow: "none !important"
              }
            }
          });
        },
        indicatorSeparator: function indicatorSeparator(base) {
          return _extends({}, base, {
            backgroundColor: "rgb(234 236 240)"
          });
        },
        indicatorsContainer: function indicatorsContainer(base) {
          return _extends({}, base, {
            height: props.customHeight ? "".concat(props.customHeight, "px") : base.height
          });
        },
        menu: function menu(base) {
          return _extends({}, base, {
            border: "1px solid rgb(234 236 240)",
            backgroundColor: "#ffffff",
            boxShadow: "none",
            zIndex: 100
          });
        },
        menuPortal: function menuPortal(base) {
          return _extends({}, base, {
            borderColor: "red",
            zIndex: 100
          });
        },
        menuList: function menuList(base) {
          return _extends({}, base, {
            fontSize: 14
          });
        },
        singleValue: function singleValue(base) {
          return _extends({}, base, {
            height: props.customHeight ? "".concat(props.customHeight, "px") : base.height,
            lineHeight: props.customHeight ? "".concat(props.customHeight, "px") : base.lineHeight,
            color: selectTheme === "orange" ? "#E04F16" : base.color
          });
        },
        multiValue: function multiValue(base) {
          return _extends({}, base, {
            paddingInline: 2,
            borderRadius: 20,
            display: "inline-flex",
            alignItems: "center",
            marginTop: props.customHeight ? '0px' : base.marginTop
          });
        },
        multiValueLabel: function multiValueLabel(base) {
          return _extends({}, base, {
            fontSize: 12
          });
        },
        multiValueRemove: function multiValueRemove(base) {
          return _extends({}, base, {
            height: 20,
            width: 20,
            borderRadius: 500
          });
        },
        valueContainer: function valueContainer(base) {
          return _extends({}, base, {
            padding: props.noSeparator ? '0 0 0 4px' : props.customHeight ? '0 8px' : base.padding,
            height: props.customHeight ? "".concat(props.customHeight, "px") : base.height
          });
        },
        option: function option(base, state) {
          return _extends({}, base, {
            backgroundColor: state.isSelected ? selectTheme === "orange" ? "#FDEAD7" : "#CCBFF2" : state.isFocused ? selectTheme === "orange" ? "#FDEAD7" : "#EEE9FA" : "transparent",
            color: state.isSelected ? selectTheme === "orange" ? "#E04F16" : "#000000" : "#000000",
            "&:active": {
              backgroundColor: state.isSelected ? selectTheme === "orange" ? "#FDEAD7" : "#CCBFF2" : state.isFocused ? selectTheme === "orange" ? "#FDEAD7" : "#EEE9FA" : "transparent"
            },
            padding: props.customHeight ? '5px 8px' : base.padding
          });
        }
      }
    }, props))]
  });
};
export default Select;